export default __webpack_public_path__ + "static/media/signup1.4994fce7.jpg";